/* ===== BLANCO PARDON — Theme JavaScript ===== */

(function() {
  'use strict';

  /* ========================================= */
  /*  FADE-IN OBSERVER                          */
  /* ========================================= */
  function initFadeIn() {
    var els = document.querySelectorAll('.fade-in');
    if (!els.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ========================================= */
  /*  HEADER SCROLL                             */
  /* ========================================= */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ========================================= */
  /*  MOBILE MENU                               */
  /* ========================================= */
  function initMobileMenu() {
    var hamburger = document.querySelector('.hamburger');
    var menu = document.querySelector('.mobile-menu');
    if (!hamburger || !menu) return;

    hamburger.addEventListener('click', function() {
      var isOpen = menu.classList.toggle('active');
      hamburger.classList.toggle('active');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Submenu toggles
    var subToggles = menu.querySelectorAll('[data-submenu-toggle]');
    subToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var target = toggle.getAttribute('data-submenu-toggle');
        var sub = menu.querySelector('[data-submenu="' + target + '"]');
        var chevron = toggle.querySelector('.mobile-menu__chevron');
        if (!sub) return;

        var isOpen = sub.classList.toggle('open');
        if (chevron) chevron.classList.toggle('open', isOpen);

        // Close other submenus
        subToggles.forEach(function(other) {
          if (other !== toggle) {
            var otherTarget = other.getAttribute('data-submenu-toggle');
            var otherSub = menu.querySelector('[data-submenu="' + otherTarget + '"]');
            var otherChev = other.querySelector('.mobile-menu__chevron');
            if (otherSub) otherSub.classList.remove('open');
            if (otherChev) otherChev.classList.remove('open');
          }
        });
      });
    });

    // Close on link click
    var links = menu.querySelectorAll('a');
    links.forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('active');
        hamburger.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  /* ========================================= */
  /*  CART DRAWER                               */
  /* ========================================= */
  var CartDrawer = {
    backdrop: null,
    drawer: null,

    init: function() {
      this.backdrop = document.querySelector('.cart-drawer__backdrop');
      this.drawer = document.querySelector('.cart-drawer');
      if (!this.backdrop || !this.drawer) return;

      // Toggle buttons
      var self = this;
      document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          self.open();
        });
      });

      // Close buttons
      document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
        btn.addEventListener('click', function() { self.close(); });
      });
      this.backdrop.addEventListener('click', function() { self.close(); });
    },

    open: function() {
      this.backdrop.classList.add('active');
      this.drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    close: function() {
      this.backdrop.classList.remove('active');
      this.drawer.classList.remove('active');
      document.body.style.overflow = '';
    },

    updateCount: function(count) {
      var badges = document.querySelectorAll('.cart-count');
      badges.forEach(function(badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });
    },

    refresh: function() {
      var self = this;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          self.updateCount(cart.item_count);
          self.renderItems(cart);
        });
    },

    renderItems: function(cart) {
      var container = this.drawer.querySelector('.cart-drawer__items');
      var footer = this.drawer.querySelector('.cart-drawer__footer');
      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p class="cart-drawer__empty-text">Your cart is empty</p>' +
            '<button class="cart-drawer__empty-btn" data-cart-close>Continue Shopping</button>' +
          '</div>';
        if (footer) footer.style.display = 'none';
        // Re-bind close
        container.querySelector('[data-cart-close]').addEventListener('click', this.close.bind(this));
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        html +=
          '<div class="cart-item">' +
            '<div class="cart-item__image">' +
              (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') +
            '</div>' +
            '<div class="cart-item__details">' +
              '<div>' +
                '<p class="cart-item__title">' + item.product_title + '</p>' +
                '<p class="cart-item__variant">' + item.variant_title + '</p>' +
              '</div>' +
              '<div class="cart-item__bottom">' +
                '<div class="cart-item__qty">' +
                  '<button data-qty-change data-line="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button data-qty-change data-line="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
                '</div>' +
                '<div class="cart-item__price-wrap">' +
                  '<span class="cart-item__price">CHF ' + (item.price / 100).toFixed(2) + '</span>' +
                  '<button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Remove">' +
                    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
                  '</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      container.innerHTML = html;

      // Update footer
      if (footer) {
        footer.style.display = 'block';
        var subtotalEl = footer.querySelector('.cart-drawer__subtotal-value');
        if (subtotalEl) subtotalEl.textContent = 'CHF ' + (cart.total_price / 100).toFixed(2);
        var titleEl = this.drawer.querySelector('.cart-drawer__title');
        if (titleEl) titleEl.textContent = 'Your Cart (' + cart.item_count + ')';
      }

      // Bind quantity change
      var self = this;
      container.querySelectorAll('[data-qty-change]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.getAttribute('data-line');
          var qty = parseInt(btn.getAttribute('data-qty'));
          self.changeQty(key, qty);
        });
      });

      // Bind remove
      container.querySelectorAll('[data-remove-item]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.getAttribute('data-remove-item');
          self.changeQty(key, 0);
        });
      });
    },

    changeQty: function(key, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          self.updateCount(cart.item_count);
          self.renderItems(cart);
        });
    },

    addItem: function(variantId, quantity) {
      var self = this;
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          self.refresh();
          self.open();
        });
    }
  };

  /* ========================================= */
  /*  MEMBER POPUP                              */
  /* ========================================= */
  function initMemberPopup() {
    var backdrop = document.querySelector('.member-popup__backdrop');
    var wrap = document.querySelector('.member-popup__wrap');
    if (!backdrop || !wrap) return;

    if (sessionStorage.getItem('memberPopupDismissed')) return;

    setTimeout(function() {
      backdrop.classList.add('active');
      wrap.classList.add('active');
    }, 5000);

    function closePopup() {
      backdrop.classList.remove('active');
      wrap.classList.remove('active');
      sessionStorage.setItem('memberPopupDismissed', 'true');
    }

    backdrop.addEventListener('click', closePopup);
    var closeBtn = wrap.querySelector('.member-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    // Stop propagation on popup itself
    var popup = wrap.querySelector('.member-popup');
    if (popup) popup.addEventListener('click', function(e) { e.stopPropagation(); });

    // Form submit
    var form = wrap.querySelector('.member-popup__form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value) return;

        // Show success
        var formEl = form;
        var successEl = wrap.querySelector('.member-popup__success');
        if (formEl) formEl.style.display = 'none';
        if (successEl) successEl.style.display = 'block';

        setTimeout(closePopup, 2500);
      });
    }
  }

  /* ========================================= */
  /*  PRODUCT CAROUSEL SCROLL                   */
  /* ========================================= */
  function initCarousels() {
    document.querySelectorAll('.product-carousel').forEach(function(section) {
      var track = section.querySelector('.product-carousel__track');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!track) return;

      var scrollAmount = function() { return track.clientWidth * 0.6; };

      if (leftBtn) {
        leftBtn.addEventListener('click', function() {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (rightBtn) {
        rightBtn.addEventListener('click', function() {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
    });
  }

  /* ========================================= */
  /*  INIT                                      */
  /* ========================================= */
  document.addEventListener('DOMContentLoaded', function() {
    initFadeIn();
    initHeaderScroll();
    initMobileMenu();
    CartDrawer.init();
    CartDrawer.refresh();
    initMemberPopup();
    initCarousels();
  });

  // Expose CartDrawer globally for product page
  window.CartDrawer = CartDrawer;

})();
